<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div class="container bg-Bat text-bat">
            <div class="py-4">
                <div class="breadcrumbs-retos pb-2">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt="" />
                    </a>
                    <a v-if="nameCategory !== null" class="link cursor-pointer" href="/novedades">Informa2 </a>
                    <span v-if="nameCategory !== null" class="link color-active-miga"><strong>{{ nameCategory }}</strong></span>
                    <span v-if="nameCategory === null" class="link-disable color-active-miga"><strong>Informa2</strong></span>
                </div>
                <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
            </div>
            <div class="d-flex justify-content-start flex-column">
                <h1 class="fs-4">Informa2</h1>
                <p class="fs-6">
                    Descubre todo lo nuevo que Conectados tiene para ti
                </p>
            </div>


            <div class="container py-3">
                <div v-if="categories.length > 0" class="row justify-content-center pt-3">
                    <slick
                        v-if="categories.length"
                        ref="slick"
                        :options="slickOptionsCategories"
                        class="px-0 py-2 mb-1"
                    >
                        <div
                            v-for="(category, index) in categories"
                            :key="index"
                             class="d-flex justify-content-center "
                        >
                            <div v-if="category.adult != 1"
                            :id="category.id + '-' + category.title"
                                :title="category.title"
                                class="col-10 col-md-10 col-lg-10 mx-1 mb-3 bg-white shadow rounded-4 px-2 py-3 d-flex flex-column justify-content-start cursor-pointer"
                                :class="
                                    selectedCategory === category.id
                                        ? 'border-new-orange'
                                        : ''
                                "
                                @click="selectCategory(category.id)"
                            >
                                <img
                                    class="img-category-novelty rounded text-break fs-8 "
                                    :src="category.image"
                                    :alt="category.title"
                                />
                                <p
                                    class="fs-7 mt-2 mb-0 title-category-noveltys"
                                >
                                    {{ category.title }}
                                </p>
                            </div>
                            <div v-else
                                :id="category.id + '-' + category.title"
                                :title="category.title"
                                class="col-10 col-md-10 col-lg-10 mx-1 mb-3 bg-white shadow rounded-4 px-2 py-3 d-flex flex-column justify-content-start cursor-pointer"
                                :class="
                                    selectedCategory === category.id
                                        ? 'border-new-orange'
                                        : ''
                                "
                                data-bs-toggle="modal" data-bs-target="#modal_18"
                                @click="modalCategory(category.id)"
                            >
                                <img
                                    class="img-category-novelty rounded text-break fs-8 "
                                    :src="category.image"
                                    :alt="category.title"
                                />
                                <p
                                    class="fs-7 mt-2 mb-0 title-category-noveltys"
                                >
                                    {{ category.title }}
                                </p>
                            </div>
                        </div>
                    </slick>
                    <div class="modal fade" id="modal_18" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-sm">
                            <div class="modal-content py-3 d-flex justify-content-center text-center">
                                <img class="img-fluid w-50 mx-auto" src="/img-version2/modal/image 8.svg" alt="image 8">
                                <h3 class="my-3">¿Tienes más de 18 años?</h3>
                                <div class="modal-footer d-flex justify-content-center border-0">
                                    <button type="button" class="btn btn-secondary w-25" data-bs-dismiss="modal">No</button>
                                    <button type="button" class="btn w-25 btnBlue" data-bs-dismiss="modal"  @click="selectCategory(modalCategoryId)">Sí</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="categories.length < 1" class="text-center my-5">
                    <h4>No se encontraron Categorías</h4>
                </div>
            </div>


            <div v-if="selectedCategory === null" class="my-5">
                <h2 class="d-block fs-5">Últimas Noticias</h2>
                <div v-if="news.length" class="row justify-content-center justify-content-md-between p-0 p-md-2">
                    <div class="row my-4 d-flex justify-content-start">
                        <div
                            v-for="noticias in news"
                            class="col-12 col-md-6 col-lg-4 mb-3  px-0 px-md-2"
                        >
                            <a
                                :href="'/detalle-novedades/' + noticias.id "
                                class="row d-flex justify-content-center mx-1 mx-md-3 text-dark align-items-center cursor-pointer text-decoration-none py-3 shadow-sm rounded-4"
                            >
                                <div class="col-4 text-center px-1">
                                    <img
                                        class="img-fluid rounded text-break fs-8 object-fit-cover"
                                        :src="noticias.icon"
                                        :alt="noticias.title"
                                    />
                                </div>
                                <div class="col-6">
                                    <span class="fs-7">
                                        {{
                                            formatDate(
                                                new Date(noticias.start_date)
                                            )
                                        }}
                                    </span>
                                    <h3 class="fs-6 truck-title">
                                        {{ noticias.title }}
                                    </h3>
                                </div>
                                <div class="col-2 text-center">
                                    <a
                                        :href="'/detalle-novedades/' + noticias.id "
                                        class="text-indigo-darkness text-decoration-none"
                                    >
                                        <i
                                            class="fa-solid fa-arrow-right-long"
                                        ></i>
                                    </a>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="news.length" class="row justify-content-center justify-content-md-between p-0 p-md-2">
                    <h2
                        class="d-block text-indigo fs-5"
                        v-if="selectedCategory"
                    >
                        {{ selectedCategory.title }}
                    </h2>
                    <div class="row my-4 d-flex justify-content-start">
                        <div
                            v-for="noticias in news"
                            class="col-12 col-md-6 col-lg-4 mb-3 px-0 px-md-2"
                        >
                            <a
                                :href="'/detalle-novedades/' + noticias.id "
                                class="row d-flex justify-content-center mx-1 mx-md-3 text-dark align-items-center cursor-pointer text-decoration-none py-3 shadow-sm rounded-4"
                            >
                                <div class="col-4 text-center px-1">
                                    <img
                                        class="img-fluid rounded text-break fs-8 object-fit-cover"
                                        :src="noticias.icon"
                                        :alt="noticias.title"
                                    />
                                </div>
                                <div class="col-6">
                                    <span class="fs-7">
                                        {{
                                            formatDate(
                                                new Date(noticias.start_date)
                                            )
                                        }}
                                    </span>
                                    <h3 class="fs-6 truck-title">
                                        {{ noticias.title }}
                                    </h3>
                                </div>
                                <div class="col-2 text-center">
                                    <a
                                        :href="'/detalle-novedades/' + noticias.id "
                                        class="text-indigo-darkness text-decoration-none"
                                    >
                                        <i
                                            class="fa-solid fa-arrow-right-long"
                                        ></i>
                                    </a>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center my-5">
                    <h4>No se encontraron noticias en esta categoria</h4>
                </div>
            </div>
            <div class="d-flex justify-content-center text-bat align-items-center">
                <!-- Botones de navegación -->
                <button class="mx-2 border-0 bg-transparent text-secondary" @click="prevPage(selectedCategory, currentPage )" :disabled="currentPage === 1">
                    &lt;
                </button>
                <div class="page-numbers d-flex align-items-center">
                    <!-- Números de página -->
                    <button
                        v-for="page in pageNumbers"
                        :key="page"
                        class="mx-2 border-0 bg-transparent"
                        @click="getNewsPage(selectedCategory, page)"
                        :class="{ 'text-title-bat text-orange-pagination fs-5': currentPage === page }"
                    >
                        {{ page }}
                    </button>
                </div>
                <button class="mx-2 border-0 bg-transparent text-secondary" @click="nextPage(selectedCategory, currentPage )" :disabled="currentPage === lastPage">
                    >
                </button>
            </div>
        </div>
    </div>
 </template>


 <script>
 import Slick from "vue-slick";
 import "slick-carousel/slick/slick.css";
 export default {
    components: { Slick },
    props: {
        url_media: {
            default: "",
        },
    },
    data() {
        return {
            loading: 0,
            news: [],
            categories: [],
            selectedCategory: null,
            slickOptionsCategories: Object,
            currentPage: null,
            lastPage: null,
            page: 1,
            itemsPerPage: 6,
            items: 0,
            modalCategoryId: null,
            nameCategory: null,
        };
    },
    mounted() {
        this.slickOptionsProps();
        // this.items = this.mq;
        this.selectCategory(this.selectedCategory, this.currentPage);
    },
    created() {
        this.mq2();
        const urlParams = new URLSearchParams(window.location.search);
        this.selectedCategory = parseInt(urlParams.get('category')) || null;
        this.currentPage = parseInt(urlParams.get('page')) || 1;
        // this.items = parseInt(urlParams.get('items')) || this.mq;
        // this.items = this.mq;
        this.selectCategory(this.selectedCategory, this.currentPage);


    },
    computed: {
        mq() {
            if(this.$mq === 'sm'){
                this.items = 6;
                return 6;
            }else{
                this.items = 15;
                return 15;
            }
        },
        pageNumbers() {
            if (this.lastPage === null) {
                return [];
            }
            return Array.from(
                { length: this.lastPage },
                (_, index) => index + 1
            );
        },
        currentPageData() {
            if (this.news === null) {
                return [];
            }
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.news.slice(startIndex, endIndex);
        },
    },
    methods: {
        updateURL() {
            const queryParams = new URLSearchParams();
            let url = '';
            if (this.selectedCategory !== null) {
                queryParams.set('category', this.selectedCategory);
            }
            if (this.currentPage !== 1 ) {
                queryParams.set('page', this.currentPage);
            }
            queryParams.set('items', this.items);
            url += `?${queryParams.toString()}`;
            window.history.pushState({}, '', url);
        },
        mq2() {
            if(this.$mq === 'sm'){
                this.items = 6;
            }else{
                this.items = 15;
            }
        },
        selectCategory(category, page = 1) {
            this.selectedCategory = category;
            this.loading++;
            this.mq2();
            axios
                .get(`/get-news?page=${page}&mq=${this.items}&category=${this.selectedCategory}`)
                .then(({ data }) => {
                    this.categories = data.categories;
                    const arrayCategory = this.categories.find(categoryData => categoryData.id === category);
                    if(arrayCategory){
                        this.nameCategory = arrayCategory.title;
                    }else{
                        this.nameCategory = null;
                    }


                    this.news = Array.isArray(data.news.data)
                        ? data.news.data
                        : Object.values(data.news.data);
                    this.currentPage = data.news.current_page;
                    this.lastPage = data.news.last_page;
                    this.loading--;
                    window.scrollTo(0, 0);
                    this.updateURL();
                });
        },
        modalCategory(category){
            this.modalCategoryId = category;
        },
        getNewsPage(selectedCategory, page) {
            this.selectCategory(selectedCategory, page);
        },
        prevPage(selectedCategory, currentPage ) {
            if (this.currentPage > 1) {
                this.page = currentPage - 1;
                this.getNewsPage(selectedCategory, this.page);
            }
        },
        nextPage(selectedCategory, currentPage ) {
            if (this.currentPage < this.lastPage) {
                this.page = currentPage + 1;
                this.getNewsPage(selectedCategory, this.page);
            }
        },
        formatDate(date) {
            const months = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ];
            const month = months[date.getMonth()];
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month} ${day} / ${year}`;
        },
        slickOptionsProps() {
            this.slickOptionsCategories = {
                dots: false,
                arrows: true,
                infinite: false,
                centerMode: false,
                autoplay: false,
                slidesToShow: 10,
                slidesToScroll: 1,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 10,
                            slidesToScroll: 2,
                            dots: false,
                            arrows: false,
                        },
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true,
                            arrows: false,
                        },
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true,
                            arrows: false,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3.2,
                            slidesToScroll: 2,
                            centerMode: false,
                            arrows: false,
                            infinite: false,
                        },
                    },
                ],
            };
        },
    },
 };
 </script>



